import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'
import { Navigate } from 'react-router-dom'
import AccountPage from '@/account/components/AccountPage'
import { isPaxtonBrand } from '@/util/enterprise'

const AccountPageGuard = () => {
  const { user, userAccountData } = useContext(AuthContext)
  const isOrgAccount = userAccountData?.isOrgAccount
  const isOrgAdmin = userAccountData?.isOrgAdmin

  // Check that the user is a logged in Paxton user
  if (userAccountData && user && !user.isAnonymous && isPaxtonBrand()) {
    // Individual accounts see the account page
    if (!isOrgAccount) return <AccountPage />

    // Org Admins are redirected to the admin dashboard
    if (isOrgAccount && isOrgAdmin) {
      return <Navigate to="/dashboard/admin" replace />
    }
  }

  // Everything else falls back to the dashboard
  return <Navigate to="/dashboard" replace />
}

export default AccountPageGuard
